import React from 'react';
import { Link } from 'react-router-dom';
import ColourTextLogo from '../../../../colour_text_logo.svg';
import './TermsOfServiceScreen.css';

const TermsOfServiceScreen = () => {
  return (
    <div className="legal-screen">
      <div className="legal-container">
        <div className="legal-gradient-header"></div>
        <div className="legal-card-content">
          <img src={ColourTextLogo} alt="Framework" className="legal-logo" />
          
          <h1 className="legal-title">Terms of Service</h1>
          <p className="legal-last-updated">Last updated: {new Date().toLocaleDateString('en-AU', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <div className="legal-content">
            <section>
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing or using our Enterprise Prompt Library service ("the Service"), you agree to be bound by these Terms of Service and all applicable Australian laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing the Service.
              </p>
            </section>

            <section>
              <h2>2. Description of Service</h2>
              <p>
                Our Enterprise Prompt Library is a platform designed to help users find and use frameworks with whatever Generative AI (GenAI) tool they choose. The Service provides access to a library of prompts, frameworks, and related resources to assist users in their GenAI workflows.
              </p>
            </section>

            <section>
              <h2>3. User Accounts</h2>
              <p>To access certain features of the Service, you must create an account. You agree to:</p>
              <ul>
                <li>Provide accurate, current, and complete information during registration</li>
                <li>Maintain and promptly update your account information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Accept responsibility for all activities that occur under your account</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
              </ul>
            </section>

            <section>
              <h2>4. User Obligations</h2>
              <p>You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to:</p>
              <ul>
                <li>Violate any applicable Australian or international laws or regulations</li>
                <li>Infringe upon the intellectual property rights of others</li>
                <li>Upload, post, or transmit any content that is harmful, offensive, or violates any third-party rights</li>
                <li>Attempt to gain unauthorized access to the Service or its related systems</li>
                <li>Use the Service in any manner that could damage, disable, or impair the Service</li>
                <li>Reverse engineer, decompile, or disassemble any part of the Service</li>
              </ul>
            </section>

            <section>
              <h2>5. Intellectual Property</h2>
              <p>
                The Service and its original content, features, and functionality are owned by us and are protected by Australian and international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
              <p>
                You retain ownership of any prompts, content, or materials you create or submit through the Service. By submitting content, you grant us a non-exclusive, worldwide, royalty-free license to use, display, and distribute your content within the Service.
              </p>
            </section>

            <section>
              <h2>6. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by Australian Consumer Law, we exclude all warranties, conditions, and terms whether express or implied. We will not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Service.
              </p>
              <p>
                Nothing in these Terms excludes, restricts, or modifies any rights you may have under the Australian Consumer Law that cannot be excluded, restricted, or modified.
              </p>
            </section>

            <section>
              <h2>7. Australian Consumer Law</h2>
              <p>
                Our goods and services come with guarantees that cannot be excluded under the Australian Consumer Law. You are entitled to a replacement or refund for a major failure and compensation for any other reasonably foreseeable loss or damage. You are also entitled to have the goods repaired or replaced if the goods fail to be of acceptable quality and the failure does not amount to a major failure.
              </p>
            </section>

            <section>
              <h2>8. Service Availability</h2>
              <p>
                We do not guarantee that the Service will be available at all times or that it will be error-free. We reserve the right to modify, suspend, or discontinue the Service (or any part thereof) at any time with or without notice.
              </p>
            </section>

            <section>
              <h2>9. Termination</h2>
              <p>
                We may terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.
              </p>
              <p>
                You may terminate your account at any time by contacting us or through your account settings.
              </p>
            </section>

            <section>
              <h2>10. Dispute Resolution</h2>
              <p>
                If you have a dispute with us, you agree to first contact us to attempt to resolve the dispute informally. If we cannot resolve the dispute informally, you agree that any disputes arising out of or relating to these Terms or the Service will be resolved through binding arbitration in accordance with the rules of the Australian Centre for International Commercial Arbitration, or through the courts of Australia, as applicable.
              </p>
            </section>

            <section>
              <h2>11. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of Australia, without regard to its conflict of law provisions. Any disputes relating to these Terms or the Service will be subject to the exclusive jurisdiction of the courts of Australia.
              </p>
            </section>

            <section>
              <h2>12. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the new Terms on this page and updating the "Last updated" date. Your continued use of the Service after such modifications constitutes your acceptance of the modified Terms.
              </p>
            </section>

            <section>
              <h2>13. Contact Information</h2>
              <p>
                If you have any questions about these Terms of Service, please contact us through your account settings or support channels.
              </p>
            </section>
          </div>

          <div className="legal-footer">
            <Link to="/privacy-policy" className="legal-link">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceScreen;

